import { render, staticRenderFns } from "./CloudBubble.vue?vue&type=template&id=38fbb1d6&scoped=true"
import script from "./CloudBubble.vue?vue&type=script&lang=js"
export * from "./CloudBubble.vue?vue&type=script&lang=js"
import style0 from "./CloudBubble.vue?vue&type=style&index=0&id=38fbb1d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fbb1d6",
  null
  
)

export default component.exports